export default __webpack_public_path__ + "static/media/pic4.6bca8077.jpg";